import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    setKeyword("");
  };

  return (
    <footer className="mt-16 bg-primary-700 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-clapperboard-line text-xl"></i>
              </span>
              <span className="text-xl font-bold tracking-wide text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                爱妻艺
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              爱妻艺致力于为用户提供丰富的影视作品和最新娱乐资讯，涵盖电影、电视剧、综艺等多类别内容，满足多元化的观影和娱乐需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="/category/movie" className="cursor-pointer">影视分类</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link to={category.path} className="cursor-pointer transition-colors hover:text-accent-400">
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="/about" className="cursor-pointer">关于我们</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <Link to="/news" className="cursor-pointer transition-colors hover:text-accent-400">
                  娱乐资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">
                  版权声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="/search" className="cursor-pointer">站内搜索</a>
            </h4>
            <form onSubmit={handleSearch} className="mt-4">
              <div className="flex items-center gap-2 rounded-full bg-primary-800 px-3 py-2">
                <i className="ri-search-line text-base text-background-300"></i>
                <input
                  type="search"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="输入关键词"
                  className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-400"
                />
              </div>
            </form>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-wechat-fill", label: "微信" },
                { icon: "ri-tiktok-fill", label: "抖音" },
                { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
              ].map((social) => (
                <span
                  key={social.label}
                  title={social.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-800 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${social.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-600 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 爱妻艺 AIQIYI MEDIA. 保留所有权利。</p>
          <p>本站内容为演示用途，不提供任何影视播放或下载功能。</p>
        </div>
      </div>
    </footer>
  );
}